// /components/reports/components/StudentSelector.js
import React from 'react';
import { Form } from 'react-bootstrap';

function StudentSelector({ students, selectedUsers, onChange }) {
  return (
    <Form.Group controlId="userSelect">
      <Form.Label>4. Select Students (optional, all if empty)</Form.Label>
      <Form.Select
        multiple
        htmlSize={5}
        name="selectedUsers"
        value={selectedUsers}
        onChange={onChange} // This is the multi-select handler
      >
        {students.length > 0 ? (
          students.map((student) => (
            <option key={student._id} value={student._id}>
              {student.name}
            </option>
          ))
        ) : (
          <option disabled>No students in this class</option>
        )}
      </Form.Select>
    </Form.Group>
  );
}

export default StudentSelector;